import React from 'react';
import './error.styles.scss';

function Error() {
    return (
        <div className='error-page'>
            <h1>Oops!</h1>
            <h2>The page you are looking for doesn't exist.</h2>
        </div>
    );
}

export default Error;
